/**
 * Handle form submit events
 */
const formSubmit = (function (window, jQuery) { // eslint-disable-line no-unused-vars
	'use strict';

	function setupFormSubmit (searchValue) {

	}
	jQuery('body').on('click', '[name=btn_accept]', function () {
		var nextPage = jQuery(this).data('next-page');
		var $input = jQuery('<input>').prop({
			type:'hidden',
			name:'next_page',
			value: nextPage
		});
		jQuery(this).closest('form').append($input);

		var action = jQuery(this).data('action');
		if(!action) {
			return;
		}
		$input = jQuery('<input>').prop({
			type:'hidden',
			name:'next_page_action',
			value: action
		});
		jQuery(this).closest('form').append($input);
	});
	return {
		setupFormSubmit: setupFormSubmit
	};
}(window, jQuery));
